"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * Line graphs can be used to show how something changes over time.
 *
 * The LineGraph component displays a themed version of a line graph, built
 * on top of the `victory` library.
 *
 * It accepts a `data` prop, which is passed to both the inner `VictoryLine` &
 * `VictoryScatter` components, and it used to render the graph data.
 *
 * There are also `LineProps` and `ScattersProps` props that accept objects that
 * will be spread to the respective victory component. All other unhandled props
 * are spread to the root `VictoryChart` component.
 *
 * The LineGraph component is also lazy-loaded via `React.lazy` and `Suspense`,
 * when imported as a named import via `#component`, `#component/base`, or from
 * `#component/base/LineGraph`. If this code-splitting is undesirable, it can
 * also be imported directly via `#component/base/LineGraph/LineGraph`.
 *
 * For more details, refer to the Victory docs at:
 * https://formidable.com/open-source/victory/docs
 */
const LoadableLineGraph = props => (0, _pragma.createFelaElement)(_.LazyLoad, _extends({}, props, {
  importFunction: () => Promise.resolve().then(() => _interopRequireWildcard(require("./LineGraph")))
}));

LoadableLineGraph.displayName = 'LoadableLineGraph';
var _default = LoadableLineGraph;
exports.default = _default;
//# sourceMappingURL=LoadableLineGraph.js.map